import { notification } from 'antd';

export const isMobile = () => window.innerWidth < 768;

const getPlacement = () => (isMobile() ? 'top' : 'bottomRight');

export function NotificationSucces(message: string) {
  return notification.success({
    message: message,
    placement: getPlacement(),
  });
}

export function NotificationError(message: string) {
  return notification.error({
    message: message,
    placement: getPlacement(),
  });
}

export function NotificationInfo(message: string) {
  return notification.info({
    message: message,
    placement: getPlacement(),
  });
}
